/**
 * AcronIQ Veritus Report Builder API Helper
 * Frontend functions for interacting with report generation endpoints
 */

/**
 * Generate a structured report from tagged items
 * @param {Object} payload - Report generation payload
 * @param {string} payload.transcript - Optional conversation transcript
 * @param {Array} payload.items - Array of tagged items
 * @returns {Promise<Object>} Generated report data
 */
export async function generateReport(payload) {
  try {
    const response = await fetch('/api/report/generate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.report;
  } catch (error) {
    console.error('Report generation failed:', error);
    throw error;
  }
}

/**
 * Get list of allowed tags for report items
 * @returns {Promise<Array<string>>} Array of allowed tag names
 */
export async function getAllowedTags() {
  try {
    const response = await fetch('/api/report/tags', {
      method: 'GET',
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.tags;
  } catch (error) {
    console.error('Failed to fetch allowed tags:', error);
    throw error;
  }
}
